import * as React from "react";

import {
	type ModulePreviewContextProps,
	ModulePreviewContext,
} from "../contexts/ModulePreview";

export function useModulePreview(): ModulePreviewContextProps {
	const value = React.useContext(ModulePreviewContext);

	if (!value) {
		console.warn("Griddo: You forgot to put <ModulePreviewProvider>.");
		return {} as ModulePreviewContextProps;
	}

	return value;
}
